import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material';
import { Amplify } from 'aws-amplify';
import config from './amplifyconfiguration.json';
import { SignedIn, SignedOut, SignInButton, SignUpButton, UserButton } from '@clerk/clerk-react';

export default function NavBar() {
    Amplify.configure(config);

    const theme = createTheme({
        palette: {
            primary: {
                main: '#607d8b',
            },
            secondary: {
                main: '#455a64',
            }
        },
    });

  return (
    <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1, paddingBottom: '1.5vh'}}>
        <AppBar position="static">
            <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Stream It
            </Typography>
            <SignedOut>
              <SignInButton />
              <SignUpButton />
            </SignedOut>
            <SignedIn>
              <Button href= "/home" color="inherit">Home</Button>
              <Button href="/TvShows" color="inherit">TV Shows</Button>
              <UserButton />
            </SignedIn>
            </Toolbar>
        </AppBar>
        </Box>
    </ThemeProvider>
  );
}